import { render, staticRenderFns } from "./TotalTime.vue?vue&type=template&id=65431442&scoped=true"
import script from "./TotalTime.vue?vue&type=script&lang=js"
export * from "./TotalTime.vue?vue&type=script&lang=js"
import style0 from "./TotalTime.vue?vue&type=style&index=0&id=65431442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65431442",
  null
  
)

export default component.exports